// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"661":"c71c0f2c","725":"c71c0f2c"}[chunkId] + ".chunk.css";
};